angular.module('com.vmware.vsphere.client.vm').directive('vmOptions', [
   function() {
   return {
      templateUrl: 'vm-ui/resources/vm/views/settings/vmOptions/vmOptions.html',
      controller: 'VmOptionsController',
      controllerAs: 'vmOptionsController'
   };
}]);
